import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ShowContactsPage } from '@/contacts/pages/show';
import { getContactQueryOptions } from '@/contacts/queries';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/contacts/$contactId')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  loader: ({ context: { queryClient }, params: { contactId } }) => {
    const parsedContactId = parseInt(contactId);
    return queryClient.ensureQueryData(getContactQueryOptions(parsedContactId));
  },
  component: ShowContactRoute
});

export function ShowContactRoute() {
  const contactId = Route.useParams().contactId;
  const parsedContactId = parseInt(contactId);
  const { data: contact } = useSuspenseQuery(getContactQueryOptions(parsedContactId));

  return (
    <ShowContactsPage contactId={parsedContactId} contact={contact} />
  );
}
